<template>
  <!-- <div> -->
    <!-- <div> -->
      
      <!-- <div class="form-group mb-4" style="float: right; margin-left: 120px">
        <download-excel id="excel" class="btn btn-sm btn-outline-light color-default" style="
            border: 1px solid #48a6a6;
            padding: 8px 13px;
            margin-right: 6px;
            cursor: pointer;
          " :name="excelFileName" :data="demoRequests" :fields="json_fields">
          <i class="fa fa-file-excel-o" style="font-size:30px"></i>
        </download-excel>
      </div> -->
    <!-- </div> -->
    <div class="card card-body p-0 col-12" style="border-radius: 10px">
      <admin-panel-filters class="" :tags="tags" :page="page" :status="status" :demoRequests="demoRequests" :userProducts="userProducts" :products="products" @softwareFilter="setSoftware" @totalDemo="totalDemo" @setPage="setPage" @setStatus="setStatus" @skeletonLoader="setskeletonLoader"
        @selecttabe="selTab" @followupFilter="followupFilter" @changeColor="setFilterColor" @assigned_filter="setassign_filter" @crm_id="setcrm_id" @leadTag="setTag" @setDateFilters="setdatefilters">
      </admin-panel-filters>

      <demo-requests-table :isLoading="isLoading" :fullpage="fullPage" :loader="loader" :demoRequests="demoRequests"
        :total_demo="totalLeads" :totalRows="totalRows" :totalPages="totalPages" :page="page" :status="status" :setskeletonLoader="displayLoader"
        :flag="flag" :demo_flag="demo_flag" @setPage="setPage" :selTab="sel_tab" :followup_filter="followup_filter" :colorFilter="colorFilter"
        :assign_filter="assign_filter" :crm_id="crm_id" :tag="tag" :from_date="fromDate" :to_date="toDate">
      </demo-requests-table>
    </div>
  <!-- </div> -->
</template>

<script>
  import helpers from "@/helpers.js";
  import DemoRequestsTable from "./demo_requests_table";
  import adminPanelFilters from "../adminPanelFilters";
  
  import "vue-loading-overlay/dist/vue-loading.css";
  import $ from "jquery";

  export default {
    name: "demo-requests",
    components: {
      adminPanelFilters,
      DemoRequestsTable,
    },
    data: function () {
      return {
        followup_filter: 'all',
        isLoading: false,
        fullPage: true,
        loader: "bars",
        page: 0,
        total_demo: 0,
        sel_tab: 'all',
        flag: true,
        colorFlag: false,
        demo_flag: false,
        status: 'all',
        sortBy: '',
        // fullPage:'',
        colorFilter: "",
        assign_filter:"",
        crm_id:"",
        software: "all",
        displayLoader: false,
        tag:0,
        request_from: null,
        request_to: null,
        followup_from: null,
        followup_to: null,
        fromDate: null,
        toDate: null
      };
    },

    computed: {
      demoRequests: function () {
        return this.$store.getters["users/demoRequests"];
      },
      totalPages: function () {
        return this.$store.getters["users/totalPages"];
      },
      totalLeads: function () {
        return this.$store.getters["users/totalLeads"];
      },
      totalRows: function () {
        return this.$store.getters["users/totalRows"];
      },
      userProducts: function () {
        return this.$store.getters["persist/userProducts"];
      },
      products: function () {
        return this.$store.getters['persist/availableProducts'];
      },
      tags: function(){
        return this.$store.getters["users/tags"];
      },
    },

    created: function () {
      
      if(localStorage.getItem('tab') == "all" ){
        this.status = localStorage.getItem("tab");
      }else{
        this.status =localStorage.getItem('tab');
      }
      this.software = localStorage.getItem('software_filter');
      this.page = helpers.getPageQuery();
      this.colorFilter = "";
    },

    watch: {
      page: function (val) {
        // let loader = this.$loading.show({
        //     loader: 'dots',
        //     container: this.fullPage ? null : this.$refs.formContainer,
        // });
        this.setskeletonLoader(true);
        //console.log("page",thi= )
        let direction = localStorage.getItem('direction');
        let column = localStorage.getItem('column');
        direction === 'true' ? this.sortBy = "asc" :  this.sortBy = "desc";
         // if (localStorage.getItem('direction') != null) {
         //   console.log("page =>",val)
             this.$store.dispatch('users/getAllDemoRequests', [val, "", localStorage.getItem('tab') != null ? localStorage.getItem('tab') : 'all',
               this.request_from, this.request_to, this.followup_from, this.followup_to, this.sortBy, column,'','all',
               localStorage.getItem('demo_filter') != null ? localStorage.getItem('demo_filter') : 'all',this.software,'all','',this.tag,this.fromDate,this.toDate])
             .then(() => {
              //  loader.hide();
              this.setskeletonLoader(false);
             });
         // }

      }
     
    },

    methods: {
      setPage(page,fromDate,toDate) {
        this.page = page;
        this.setdatefilters(fromDate,toDate)
        // this.$router.push("demo-leads?page=" + page).catch(err => {});
      },
      //  setPageAdmin(page) {
      //   this.page = page;
      //   // this.$router.push("demo-leads?page=" + page);
      // },
      followupFilter(event){
          this.followup_filter = event;
      },
      selTab(event) {
        this.sel_tab = event;
        localStorage.setItem("tab", event);
      },
      setStatus(status) {
        this.status = status;
      },
      totalDemo(event) {
        this.total_demo = event;
      },
      setFilterColor(event) {
        this.colorFilter = _.cloneDeep(event);
      },
      setSoftware(event) {
        this.software = event;
      },
      setassign_filter(event) {
        this.assign_filter = _.cloneDeep(event);
      },
      setcrm_id(event) {
        this.crm_id = _.cloneDeep(event);
      },
      setTag(event) {
        this.tag = event;
      },
      
      
      setskeletonLoader(event){
        this.displayLoader = event;
        this.$forceUpdate();
      },

      setdatefilters(fromDate, toDate){
        this.fromDate = fromDate;
        this.toDate = toDate;
      }
    },
  };
</script>
<style scoped>
  .custom {
    position: absolute;
    z-index: 999;
    top: 246px;
    left: 40%;
    opacity: 0.5;
  }

  .swicth_dashboard_btn{
    display: none;
  }
 
</style>